import ChipDeleteIcon from '../../components/ChipDeleteIcon';
import { colors } from '../constants';
import { oriGrey } from '../constants/colors';
import shape from '../shape';
import { jsx as _jsx } from "react/jsx-runtime";
const styleOverrides = {
  root: {
    fontWeight: 'bold',
    fontSize: 12,
    borderRadius: shape.borderRadius,
    paddingTop: 5,
    paddingBottom: 5,
    lineHeight: '1.2',
    height: 26
  },
  sizeMedium: {
    fontSize: 14,
    height: 30
  },
  label: {
    paddingLeft: 10,
    paddingRight: 10
  },
  outlined: {
    borderColor: 'currentColor',
    borderWidth: 1,
    backgroundColor: 'unset'
  }
};
const defaultProps = {
  size: 'small',
  deleteIcon: _jsx(ChipDeleteIcon, {})
};
const variants = [{
  props: {
    variant: 'filled',
    color: 'default'
  },
  style: {
    backgroundColor: colors.blueGreyBackground[300],
    color: colors.commonColors.white
  }
}, {
  props: {
    variant: 'outlined',
    color: 'default'
  },
  style: {
    color: colors.blueGreyBackground[300]
  }
}, {
  props: {
    variant: 'rounded'
  },
  style: {
    borderRadius: 999,
    backgroundColor: oriGrey[100],
    height: 32,
    paddingLeft: 15,
    paddingRight: 15,
    color: colors.defaultColors.main
  }
}];
export default {
  styleOverrides,
  defaultProps,
  variants
};